export const urls = {
    prod: {
        customerSupport: 'https://www.nemos.io/support/'
    }
};
